module.exports = __webpack_public_path__ + "static/media/backbuttn.1119fdcd.svg";